// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  api_link:'https://api.test.n2xpress.com',
  // api_link:'http://127.0.0.1:8000',
  PSI_FORM_URL:'https://stagingcheckout.psigate.com/HTMLPost/HTMLMessenger',
  PSI_STORE_KEY_DB:'VVphwSUpVgkhfLGg2AU200017',
  PSI_STORE_KEY_CC:'VVphwSUpVgkhfLGg2AU200017',
  BCC_MAIL_ADDRESS:"porwaljayneet97@gmail.com",
  api_link_careasons:"https://api.payments.test.alphafortress.com",
  app_url:"https://n2ui.vercel.app",
  machnetUrl: "https://sandbox.api.machpay.com/v2/widget/widget.js",
  celotoaddress:"DF8AkJUGF1j8emv9JSnYJz7zRJ8JKasNZR",
  firebaseConfig : {
    //old config
    apiKey: "AIzaSyA4WKATmj7L93y0JZv2rnsoAeD5RNbMis8",
    authDomain: "n2xpress.firebaseapp.com",
    projectId: "n2xpress",
    storageBucket: "n2xpress.appspot.com",
    messagingSenderId: "565301449900",
    appId: "1:565301449900:web:46c1b093fe87bc5dec3b09",
    measurementId: "G-LD6B8WNQ1K"
    //new staging config
    // piKey: "AIzaSyDVdAztyQtVP5pUoTSwebf8b42yc3PsO5s",
    // authDomain: "n2xpress-staging.firebaseapp.com",
    // projectId: "n2xpress-staging",
    // storageBucket: "n2xpress-staging.appspot.com",
    // messagingSenderId: "513379491271",
    // appId: "1:513379491271:web:5592a18b58d3b27f7d0de2",
    // measurementId: "G-X5RBDXQG75"
  },
  googleClientId:"565301449900-ilfmfrv106cjcqkvg96pgjultov4tvda.apps.googleusercontent.com"
  // app_url:"http://localhost:4200"
};



/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
